import React, { Component } from 'react';
export default class Downloads extends Component {
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-sm-8 card mt-3 px-0">
                        <div className="card-header">
                            <h4>Download Forms</h4>
                        </div>
                        <div className="card-body px-0 py-0">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                    <a className="mr-2 text-black " href="/downloads/gst_registration_template.xlsx" download={true}><i className="nav-icon fa fa-download"></i></a>
                                    GST registration template
                                </li>
                                <li className="list-group-item">
                                    <a className="mr-2 text-black" href="/downloads/tds_deduction_undertaking.docx" download={true}><i className="nav-icon fa fa-download"></i></a>
                                    TDS deduction undertanking on company letter head              
                                </li>                             
                                <li className="list-group-item">
                                    <a className="mr-2 text-black" href="/downloads/gst_terms_of_engagement_for_registered_vendors.docx" download={true}><i className="nav-icon fa fa-download"></i></a>                                
                                GST terms of engagement for registered vendors                                
                                </li>                              
                                <li className="list-group-item">
                                    <a className="mr-2 text-black" href="/downloads/gst_undertaking_for_non_registration.docx" download={true}><i className="nav-icon fa fa-download"></i></a>
                                GST undertaking for non-registration
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
